function selectAuthoritativeLatestSession(summary, schedulerStatus) {
  if (schedulerStatus && schedulerStatus.latestStripeSession) {
    return schedulerStatus.latestStripeSession;
  }

  return summary && summary.latestStripeSession ? summary.latestStripeSession : null;
}

module.exports = {
  selectAuthoritativeLatestSession,
};
